import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../../components/icon';
var IconSocialLinkedin = React.forwardRef(function (props, ref) {
  return React.createElement(Icon, _extends({}, props, {
    content: {
      "24": {
        "height": 24,
        "width": 24,
        "source": "<path d=\"M7.08 19H3.22V7.39h3.86zM5.15 5.8a2 2 0 1 1 0-4 2 2 0 1 1 0 4zM21 19h-3.86v-6.21c0-1.56-.55-2.63-2-2.63a2.13 2.13 0 0 0-2 1.41 2.72 2.72 0 0 0-.12.94V19h-3.8V7.39h3.86V9a3.83 3.83 0 0 1 3.48-1.92C19.1 7.11 21 8.77 21 12.34z\"></path>"
      }
    },
    ref: ref
  }));
});
IconSocialLinkedin.displayName = 'IconSocialLinkedin';
IconSocialLinkedin.defaultProps = {
  size: 16
};
export default IconSocialLinkedin;